<script setup lang="ts">
import FooterLinksList from '@/components/Footer/footer-links/FooterLinksList.vue'

const SUPPORT_LINKS = [
  {
    title: 'Сообщить об ошибке',
    path: '/support/',
  },
]
</script>

<template>
  <footer-links-list :links="SUPPORT_LINKS" />
</template>
